import { CircularProgress } from '@mui/material';
import Button from '@mui/material/Button';

export function EmptyDataMessage({ hasError, onReload }) {
  if (hasError) {
    return (
      <span>
        Ocorreu um erro ao carregar os dados
        {' '}
        <br />
        {' '}
        <Button
          color="primary"
          style={{ textTransform: 'none' }}
          onClick={onReload}
        >
          clique aqui para recarregar
        </Button>
      </span>
    );
  }

  return <CircularProgress />;
}
